import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import TopBar from "@/components/landing/TopBar";
import SiteFooter from "@/components/landing/SiteFooter";
import { CTAButton } from "@/components/landing/kit";
import { LEGAL } from "@/lib/legal-content";

export default function LegalPage({ slug }) {
  const doc = LEGAL[slug];
  if (!doc) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#F9FAFC]">
        <Link to="/" className="text-[#2D5BFF] underline">
          Page not found — go home
        </Link>
      </div>
    );
  }

  return (
    <div data-testid={`legal-page-${slug}`} className="min-h-screen bg-[#F9FAFC]">
      <TopBar />
      <main className="mx-auto max-w-3xl px-5 pb-24 pt-36 sm:px-6 sm:pt-40">
        <Link
          to="/"
          data-testid="legal-back-link"
          className="inline-flex items-center gap-2 font-heading text-sm font-bold uppercase tracking-wide text-[#6B7385] transition-colors hover:text-[#2D5BFF]"
        >
          <ArrowLeft className="h-4 w-4" /> Back to home
        </Link>

        <h1 className="mt-8 font-heading text-4xl font-black leading-[1] tracking-tight text-[#0F1117] sm:text-5xl">
          {doc.title}
        </h1>
        <p className="mt-3 text-sm text-[#8A909E]">{doc.updated}</p>
        <p className="mt-8 text-base leading-relaxed text-[#4B5262]">{doc.intro}</p>

        <div className="mt-12 space-y-10">
          {doc.sections.map((s) => (
            <section key={s.h}>
              <h2 className="font-heading text-xl font-bold tracking-tight text-[#0F1117] sm:text-2xl">
                {s.h}
              </h2>
              {s.p.map((para, i) => (
                <p key={i} className="mt-3 text-sm leading-relaxed text-[#4B5262] sm:text-base">
                  {para}
                </p>
              ))}
            </section>
          ))}
        </div>

        <div className="mt-16 rounded-3xl border border-[#E5E8F0] bg-white p-8 text-center shadow-sm sm:p-10">
          <p className="font-heading text-2xl font-bold tracking-tight text-[#0F1117]">
            Ready to get started?
          </p>
          <p className="mx-auto mt-2 max-w-md text-sm text-[#5B6375]">
            Book a free, no-obligation strategy call and see if a managed store is right for you.
          </p>
          <div className="mt-6 flex justify-center">
            <CTAButton size="lg" testId="legal-cta-button">
              Book My Free Strategy Call
            </CTAButton>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
